

export enum EnumCadastroStatus {
    LIBERADO = 0,
    BLOQUEADO = 1,
    DESATIVADO = 2,
}